<template>
  <div v-if="validationErrors">
    <div v-for="value in validationErrors" :key="value" class="alert alert-danger alert-dismissible fade show" role="alert">
      <h5 class="alert-heading">{{ $t('ValidationError.validation-error') }}</h5>
      {{ value }}
      <button id="close" data-test="close" type="button" data-bs-dismiss="alert" aria-label="Close" class="btn-close"></button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ValidationError',
  props: {
    errors: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    validationErrors() {
      let errors = Object.values(this.errors);
      errors = errors.flat();
      return errors;
    },
  },
};
</script>
